import { Grid, Typography } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi, postSaveObjectApi } from 'api/general';
import CustomUserList from 'app/components/List/CustomUserList';
import LoadingPopUp from 'app/components/LoadingPopup';
import { getUserFullName } from 'app/utils/appHelpers';
import { GENERAL } from 'app/utils/constants/customConstant';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import UserCustomDataTable from '../user/UserCustomDataTable';

const CustomEpostaListPage = () => {
  const [loading, setLoading] = useState(true);
  const [userList, setUserList] = useState([]);
  const [epostaList, setEpostaList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(false);
  const [roleDialogStatus, setRoleDialogStatus] = useState(false);
  const userListState = useSelector((state) => state.user.data || []);

  useEffect(() => {
    const getAPI = async () => {
      setLoading(true);

      const res = await getObjectListByPropertyApi(GENERAL, "type", 1);
      setEpostaList(res.data);

      const list = userListState.filter(user =>
        !res.data.some(emailUser => emailUser.value === user.id)
      );
      setUserList(list);

      setLoading(false);
    };
    getAPI();
  }, []);

  useEffect(() => {
    if (selectedUser && roleDialogStatus) {
      handleAddUser();
    }
  }, [selectedUser, roleDialogStatus]);

  const handleDeleteUser = async (user) => {
    Swal.fire({
      title: 'Silme İşlemi',
      text: "Eposta listesinden silmek istediğinizden emin misiniz?",
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet Sil',
      cancelButtonText: "Vazgeç"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const result = await deleteObjectApi(GENERAL, user.id);

        if (result.status) {
          const filteredList = epostaList.filter(x => x.id !== user.id);
          const removedUser = epostaList.find(x => x.id === user.id);

          if (removedUser) {
            setUserList(prevUserList => [...prevUserList, removedUser]);
          }
          setEpostaList(filteredList);

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Silme işlemi başarılı.',
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
    });
  };

  const handleAddUser = async () => {
    if (!selectedUser) return;

    Swal.fire({
      title: 'Eposta Ekleme İşlemi',
      text: "Eposta listesine eklemek istediğinizden emin misiniz?",
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet Ekle',
      cancelButtonText: "Vazgeç"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const object = {
          value: selectedUser.id,
          type: 1,
          label: getUserFullName(selectedUser),
          pdate: new Date()
        };

        const result = await postSaveObjectApi(GENERAL, object);
        if (result.status) {
          const updatedList = [selectedUser, ...epostaList];
          setEpostaList(updatedList);

          const updatedUserList = userList.filter(user => user.id !== selectedUser.id);
          setUserList(updatedUserList);

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'İşlem başarılı.',
            showConfirmButton: false,
            timer: 1500
          });

          handleDialogClose();
        }
      } else {
        setRoleDialogStatus(false);
      }
    });
  };

  const columnData = [
    { id: 'id', align: 'center', disablePadding: false, label: 'Resim' },
    { id: 'title', align: 'center', disablePadding: true, label: 'Ünvan Ad Soyad' },
    { id: 'islemler', align: 'center', disablePadding: false, label: 'İşlemler' },
  ];

  const handleDialogClose = () => {
    setRoleDialogStatus(false);
    setSelectedUser(false);
  };


  return (
    <div>
      <LoadingPopUp open={loading} />
      {!loading && (
        <>
          <Typography variant="h4" mb={3}>E-posta Ekleme</Typography>

          <Grid container>
            <Grid container spacing={3.75}>
              <Grid item xs={6} sm={6} lg={6}>
                <UserCustomDataTable
                  mainData={userList}
                  column={columnData}
                  pageTitle="Kullanıcı Listesi"
                  setSelectedUser={setSelectedUser}
                  setRoleDialogStatus={setRoleDialogStatus}
                />
              </Grid>

              <Grid item xs={6} sm={6} lg={6}>
                <Grid container spacing={3.75}>
                  <Grid item xs={12} sm={6} lg={6}>
                    <CustomUserList
                      key={epostaList.length}
                      title={'Özel Eposta Listesi'}
                      epostaList={epostaList}
                      handleDeleteUser={handleDeleteUser}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};

export default CustomEpostaListPage;